import { ListingIdentifier, ListingIdentifierForApi } from '@hcs/types';

export const prepListingIdentifierForApi = (
  listingIdentifier: ListingIdentifier
): ListingIdentifierForApi => ({
  mlsID: Number(listingIdentifier.hcMlsId),
  mlsNumber: listingIdentifier.listingId,
});
